import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';
import { DueDiligenceStatus } from 'modules/cm/domain/DueDiligence/DueDiligence';
import { Nullable } from 'utils/types';

const exportFunc = (state: State, action: Action) => {
  return {
    [ACTION_TYPES.SET_DUE_DILIGENCE_STATUS.toString()]: () => {
      return {
        ...state,
        dueDiligence: {
          status: action.payload[0] as Nullable<DueDiligenceStatus>,
        },
      };
    },
  };
};

export default exportFunc;
